/* eslint-disable i18next/no-literal-string */
import { useRouter } from 'next/router';
import { useQuery } from '@apollo/react-hooks';
import _ from 'lodash';

import useCart from 'hooks/use-cart';
import useUI from 'hooks/use-ui';

import { consumerDispensaries } from 'shared/graphql/dispensary/queries';

export const getQuery = () => consumerDispensaries;

export const getVariables = (dispensaryId, filters) => ({
  dispensaryFilter: {
    cNameOrID: dispensaryId,
    ...filters,
  },
});

export const getDispensary = async (apolloClient, props) =>
  apolloClient.query({
    query: getQuery(),
    variables: getVariables(props.params.cName),
    skip: !props.params.cName,
  });

function getError(query) {
  // eslint-disable-next-line lodash/prefer-lodash-method
  const params = Object.keys(query).join(', ');
  const error = new Error(
    `useDispensary may only be called from a route with a cName parameter. Found keys: ${params}`
  );
  error.query = query;

  return error;
}

function useFilters() {
  const Cart = useCart();
  const { isKiosk } = useUI();

  if (Cart?.currentAddress && !isKiosk) {
    return {
      city: Cart?.currentAddress?.city,
      destinationTaxState: Cart?.currentAddress?.state,
      destinationTaxZipcode: Cart?.currentAddress?.zipcode,
      nearLat: Cart?.currentAddress?.lat,
      nearLng: Cart?.currentAddress?.lng,
    };
  }

  return undefined;
}

export default function useDispensary(id) {
  const { isReady, query } = useRouter();

  const { cName, dispensaryId: dispoIdFromQuery } = query;
  const dispensaryId = id || cName || dispoIdFromQuery;

  const filters = useFilters();
  const variables = getVariables(dispensaryId, filters);

  const { data, loading, error, ...apolloValues } = useQuery(consumerDispensaries, {
    variables,
    skip: !isReady || !dispensaryId,
  });

  const dispensary =
    _.find(data?.filteredDispensaries, (d) => d.cName === cName || d.id === dispensaryId) ||
    _.head(data?.filteredDispensaries);

  if (isReady && !dispensaryId) {
    return {
      data,
      loading,
      error: getError(query),
      dispensary,
      ...apolloValues,
    };
  }

  return {
    data,
    loading: !isReady || loading,
    error,
    dispensary,
    ...apolloValues,
  };
}
